module.exports = __webpack_public_path__ + "img/AW.a7f3506f.png";